<template>
  <div class="addArticle">
    <!-- 隐藏右侧设置栏按钮 -->
    <div
      class="close"
      :class="rightSet === false ? 'active' : ''"
      @click="closeRight"
    >
      <a-icon type="left" v-if="isClose" />
      <a-icon type="right" v-else />
    </div>
    <div class="main">
      <div class="left" :class="rightSet === false ? 'active1' : ''">
        <!-- 标题和作者 -->
        <div class="top">
          <div class="title">
            标题：
            <a-input
              style="width: 90%"
              :maxLength="64"
              v-model="articleForm.title"
            />
          </div>
          <div class="author">
            作者：
            <a-input
              style="width: 90%"
              :maxLength="8"
              v-model="articleForm.author"
            />
          </div>
        </div>
        <!-- 富文本编辑器 -->
        <div class="content">
          <!-- <a-button @click="selectMiniAppShow = true">小程序</a-button> -->
          <!-- 推荐文章按钮 -->
          <a-button @click="articleVisible = true" v-show="false"
            >推荐文章</a-button
          >
          <tinymce-editor
            ref="tinymceEditor"
            :value="articleForm.content"
            @change="getMyValue"
          />
        </div>
        <!-- 摘要与预览 -->
        <div class="preview">
          <div class="zhaiyao">
            <div class="img">
              封面和摘要：
              <j-image-upload
                class="avatar-uploader"
                text="上传"
                v-model="articleForm.coverPic"
              ></j-image-upload>
            </div>
            <div class="ipt">
              <a-textarea
                v-model="articleForm.digest"
                placeholder="请输入摘要"
                :maxLength="64"
                :auto-size="{ minRows: 3, maxRows: 5 }"
              />
            </div>
          </div>
          <div class="btns">
            <a-button @click="closeCurrent">取消</a-button>
            <a-button
              class="mid"
              @click="saveArticle(0)"
              :loading="loadingButton"
              :disabled="loadingButton"
              >保存</a-button
            >
            <a-button v-if="false">预览</a-button>
          </div>
        </div>
      </div>
      <div class="right" v-if="rightSet">
        <div class="title">发布设置</div>
        <div class="cacs">
          <a-tree-select
            v-model="publishSettingsValue"
            @change="changePublishSettings"
            style="width: 100%"
            :tree-data="columnChannel"
            tree-checkable
            placeholder="请选择栏目"
          />
        </div>
        <!-- tab栏 -->
        <a-tabs type="card">
          <a-tab-pane
            v-for="item in publishSettingsTab"
            :key="item.key"
            :tab="item.name"
          >
            <div
              v-if="
                item.channelType == 1 ||
                  item.channelType == 2 ||
                  item.channelType == 3
              "
            >
              <div class="bt">
                标题：
                <a-input
                  style="width: 80%"
                  v-model="articleForm.title"
                  :readonly="true"
                />
              </div>
              <div class="zz">
                作者：
                <a-input
                  style="width: 80%"
                  v-model="articleForm.author"
                  :readonly="true"
                />
              </div>
              <div class="liuyan" v-show="false">
                设置留言：
                <a-switch
                  checked-children="开"
                  un-checked-children="关"
                  default-checked
                  v-model="item.needOpenComment"
                />
                <a-select
                  v-show="item.needOpenComment"
                  default-value="0"
                  style="width: 125px"
                  v-model="item.onlyFansCanComment"
                >
                  <a-select-option :key="0" value="0"
                    >所有人可留言</a-select-option
                  >
                  <a-select-option :key="1" value="1"
                    >粉丝才能留言</a-select-option
                  >
                </a-select>
              </div>
              <div class="lianjie" v-if="item.channel == 'integral_miniapp'">
                原文链接：
                <a-input v-model="item.origSourceUrl"></a-input>

                关键字：
                <a-switch
                  un-checked-children="关"
                  checked-children="开"
                  v-model="item.origSourceSwitch"
                />
                <a-input
                  v-show="item.origSourceSwitch"
                  v-model="articleForm.keyword"
                />
              </div>

              <div
                class="lianjie"
                v-else-if="item.channel != 'integral_miniapp'"
              >
                原文链接：
                <a-switch
                  un-checked-children="关"
                  checked-children="开"
                  v-model="item.origSourceSwitch"
                />
                <a-input
                  v-show="item.origSourceSwitch"
                  v-model="item.origSourceUrl"
                />
              </div>
              <div class="qunfa">
                分组群发：
                <a-switch
                  checked-children="开"
                  un-checked-children="关"
                  v-model="item.groupBySwitch"
                />
                <a-select
                  v-show="item.groupBySwitch"
                  default-value="0"
                  style="width: 125px"
                  v-model="item.groupByTarget"
                ></a-select>
              </div>
            </div>
            <div v-else>
              <p>暂无配置项</p>
            </div>
          </a-tab-pane>
        </a-tabs>
        <!-- 底部发送按钮 -->
        <div class="footer" v-show="publishSettings.length > 0">
          <a-button
            type="primary"
            @click="saveArticle(1)"
            :loading="loadingButton"
            :disabled="loadingButton"
            v-show="!articleAudit"
            >发送</a-button
          >
          <a-button
            type="primary"
            @click="saveArticle(2)"
            :loading="loadingButton"
            :disabled="loadingButton"
            v-show="articleAudit"
            >提交审核</a-button
          >
        </div>
      </div>
    </div>

    <!-- 选择小程序对话框 -->
    <div class="model" v-if="selectMiniAppShow">
      <div class="left">
        <h1>选择小程序</h1>
        <div
          :class="
            item.appId === currentWechatMiniApp.appId ? 'card-active' : 'card'
          "
          v-for="(item, index) in wechatMiniApp"
          :key="index"
          @click="selectMiniApp(item)"
        >
          <div
            class="avatar"
            :style="'background-image: url(\'' + item.icon + '\')'"
          ></div>
          <div class="title">{{ item.name }}</div>
        </div>
      </div>
      <div class="right">
        <h1>填写详细信息</h1>
        <div class="cx_main">
          <div class="cx_name">
            <span class="title">小程序名称：</span>
            <span>{{ currentWechatMiniApp.name }}</span>
          </div>
          <div class="cx_path">
            <span class="title">小程序路径：</span>
            <a-select
              default-value="请选择小程序页面"
              style="width: 286px"
              v-model="currentWechatMiniApp.miniAppPath"
            >
              <a-select-option
                v-for="item in wechatMiniAppPath"
                :value="item.value"
                :key="item.value"
                >{{ item.title }} {{ item.value }}</a-select-option
              >
            </a-select>
          </div>
          <div class="cx_show">
            <span class="title">展示方式：</span>
            <a-radio-group
              name="radioGroup"
              v-model="currentWechatMiniApp.showType"
              :default-value="2"
            >
              <a-radio :value="2">图片</a-radio>
              <a-radio :value="1">文字</a-radio>
              <a-radio :value="3">小程序卡片</a-radio>
              <!--<a-radio :value="4">小程序码</a-radio>-->
            </a-radio-group>
          </div>
          <div class="cx_item">
            <div
              class="item_title"
              v-if="
                !currentWechatMiniApp.showType ||
                  currentWechatMiniApp.showType == 1
              "
            >
              <span class="title">文字内容：</span>
              <a-input
                style="width: 300px"
                v-model="currentWechatMiniApp.text"
              />
              <p>点击文字会打开小程序指定的路径页面。</p>
            </div>
            <div
              class="item_img"
              v-else-if="currentWechatMiniApp.showType == 2"
            >
              <span class="title">上传图片：</span>
              <span>点击图片会打开小程序指定的路径页面。</span>
              <div class="upload">
                <j-image-upload
                  class="avatar-uploader"
                  text="上传"
                  :appId="wechatAppId"
                  v-model="currentWechatMiniApp.imageClick"
                ></j-image-upload>
              </div>
            </div>
            <div
              class="item_card"
              v-else-if="currentWechatMiniApp.showType == 3"
            >
              <span class="title">卡片标题：</span>
              <a-input
                style="width: 300px"
                :maxLength="35"
                v-model="currentWechatMiniApp.title"
              />
              <p>点击小程序卡片会打开小程序指定的路径页面。</p>
              <div class="item_c">
                <span class="title">卡片样式：</span>
                <div class="card">
                  <div
                    class="title"
                    :style="
                      'background-image: url(\'' +
                        currentWechatMiniApp.icon +
                        '\')'
                    "
                  >
                    {{ currentWechatMiniApp.name }}
                  </div>
                  <div class="upload">
                    <j-image-upload
                      class="avatar-uploader"
                      text="上传"
                      v-model="currentWechatMiniApp.imageClick"
                    ></j-image-upload>
                  </div>
                  <p>小程序封面图必须1080*864像素</p>
                </div>
              </div>
            </div>
            <div
              class="item_code"
              v-else-if="currentWechatMiniApp.showType == 4"
              style="text-align: center"
            >
              <img :src="currentWechatMiniApp.linkQr" style="width: 100px" />
            </div>
          </div>
        </div>
        <div class="footer">
          <a-button type="primary" @click="selectMiniAppShow = false"
            >取消</a-button
          >&nbsp;&nbsp;
          <a-button
            type="primary"
            @click="selectMiniAppOkay"
            :disabled="!currentWechatMiniApp.appId"
            >确定</a-button
          >
        </div>
      </div>
    </div>

    <!-- 推荐文章对话框 -->
    <div class="articleModel" v-if="articleVisible">
      <div class="left">
        <h1>选择推荐文章模板</h1>
        <a-carousel arrows :after-change="onChange">
          <div
            slot="prevArrow"
            slot-scope
            class="custom-slick-arrow"
            style="left: 10px;zIndex: 1"
          >
            <a-icon type="left" />
          </div>
          <div
            slot="nextArrow"
            slot-scope
            class="custom-slick-arrow"
            style="right: 10px"
          >
            <a-icon type="right" />
          </div>
          <div>
            <div class="img">1</div>
          </div>
          <div>
            <div class="img">2</div>
          </div>
        </a-carousel>
        <h2>预览</h2>
        <!-- 推荐模板1 -->
        <div class="yulan1" v-if="current === 0">
          <div class="tj">
            <div class="le"></div>
            <div class="rig"></div>
            <h3>推荐阅读</h3>
            <div class="a_item">
              <div class="zuo"></div>
              <div class="you">
                <h4>转折？A股冲高回落！牛市旗手回调！机会还是风险?</h4>
                <p>大盘折腾一天，虽然短暂的冲高回落111111</p>
              </div>
            </div>
            <div class="a_item">
              <div class="zuo"></div>
              <div class="you">
                <h4>转折？A股冲高回落！牛市旗手回调！机会还是风险?</h4>
                <p>大盘折腾一天，虽然短暂的冲高回落111111</p>
              </div>
            </div>
            <div class="a_item">
              <div class="zuo"></div>
              <div class="you">
                <h4>转折？A股冲高回落！牛市旗手回调！机会还是风险?</h4>
                <p>大盘折腾一天，虽然短暂的冲高回落111111</p>
              </div>
            </div>
          </div>
        </div>
        <!-- 推荐模板2 -->
        <div class="yulan2" v-if="current === 1">
          <div class="title">
            <span class="dsx"></span>
            <span class="title_item">往期回顾</span>
          </div>
          <div class="yl_item">
            <span class="l">教程</span>
            <span class="m"></span>
            <span class="y">你可能会忽略的两个高效率小工具</span>
          </div>
          <div class="yl_item">
            <span class="l">教程</span>
            <span class="m"></span>
            <span class="y">你可能会忽略的两个高效率小工具</span>
          </div>
          <div class="yl_item">
            <span class="l">教程</span>
            <span class="m"></span>
            <span class="y">你可能会忽略的两个高效率小工具</span>
          </div>
        </div>
        <div class="bc">
          <a-button @click="articleVisible = false">保存</a-button>
        </div>
      </div>
      <div class="right">
        <div class="top">
          <h1>推荐文章列表</h1>
          <div class="guize">
            <span>常用筛选规则：</span>
            <a-radio-group name="radioGroup" :default-value="1">
              <a-radio :value="1">最新文章</a-radio>
              <a-radio :value="2">订阅号-阅读量最多</a-radio>
            </a-radio-group>
            <a-button type="dashed">+自定义</a-button>
          </div>
        </div>
        <div class="bott">
          <div
            class="bott_item"
            :class="item.isLock ? 'active2' : ''"
            v-for="item in itemList"
            :key="item.id"
          >
            <!-- 锁定图标 -->
            <div class="lock" @click="item.isLock = !item.isLock">
              <a-icon type="lock" v-if="item.isLock" />
              <a-icon type="unlock" v-else />
            </div>
            <!-- 删除图标 -->
            <div class="delete" @click="deleteItem(item.id)">
              <a-icon type="delete" />
            </div>
            <div class="bott_top">
              <div class="btn">
                <a-button>{{ item.id + 1 }}</a-button>
              </div>
              <div class="handle">
                <a-button
                  type="link"
                  @click="item.isEdit = !item.isEdit"
                  v-if="item.isEdit"
                  >编辑</a-button
                >
                <a-button
                  type="link"
                  @click="item.isEdit = !item.isEdit"
                  v-if="item.isEdit === false"
                  >保存</a-button
                >
                <a-button
                  type="link"
                  @click="cancelAdd(item.id)"
                  v-if="item.isEdit === false"
                  >取消</a-button
                >
              </div>
            </div>
            <div class="bott_bot">
              <div class="url h_item">
                <span>URL：</span>
                <a-button v-if="item.isEdit" type="link">{{
                  item.url
                }}</a-button>
                <a-input
                  style="width:400px"
                  v-if="item.isEdit === false"
                  v-model="item.url"
                ></a-input>
              </div>
              <div class="bt h_item">
                <span>标题：</span>
                <span class="current1" v-if="item.isEdit">{{ item.bt }}</span>
                <a-input
                  style="width:400px"
                  v-if="item.isEdit === false"
                  v-model="item.bt"
                ></a-input>
              </div>
              <div class="zy h_item">
                <span>摘要：</span>
                <span class="current1" v-if="item.isEdit">{{ item.zy }}</span>
                <a-input
                  style="width:400px"
                  v-if="item.isEdit === false"
                  v-model="item.zy"
                ></a-input>
              </div>
              <div class="lj h_item">
                <span>头图链接：</span>
                <a-button v-if="item.isEdit" type="link">{{
                  item.lj
                }}</a-button>
                <a-input
                  style="width:200px"
                  v-if="item.isEdit === false"
                  v-model="item.lj"
                ></a-input>
              </div>
            </div>
          </div>
        </div>
        <div class="add">
          <a-button @click="addItem">添加</a-button>
        </div>
      </div>
    </div>

    <!-- 超过五篇文章 -->
    <a-modal
      title="提示"
      :visible="overVisible"
      @ok="saveArticle(3)"
      @cancel="overVisible = false"
      width="950px"
    >
      <a-table
        :columns="columns"
        :data-source="data"
        align="center"
        bordered
        :pagination="false"
        row-key="id"
      >
        <template slot="status" slot-scope="text, record">
          <span v-show="record.status == 0">待提审</span>
          <span v-show="record.status == 1">待审核</span>
          <span v-show="record.status == 2">已驳回</span>
          <span v-show="record.status == 3">可发送</span>
          <span v-show="record.status == 4">已发送</span>
        </template>
        <template slot="channelColumn" slot-scope="text, record">
          <span v-for="(item, index) in record.channels" :key="index">{{
            item
          }}</span>
        </template>
        <template slot="operation" slot-scope="text, record, index">
          <a-popconfirm
            title="确定删除该文章吗?"
            @confirm="() => deleteArticle(record.id, index)"
          >
            <a>删除</a>
          </a-popconfirm>
        </template>
      </a-table>
    </a-modal>
  </div>
</template>

<script>
import { getAction, postAction } from '@/api/manage';
import JImageUpload from '@/components/jeecg/JImageUpload';
import tinymceEditor from '@/components/tools/tinymceEditor';
// 表头标题
const columns = [
  { title: 'ID', dataIndex: 'id', key: 'id', width: '20%' },
  { title: '文章标题', dataIndex: 'title', key: 'title', width: '28%' },
  // { title: "渠道栏目", dataIndex: "channelColumn", key: "channelColumn", scopedSlots: {customRender: 'channelColumn'} },
  {
    title: '文章状态',
    dataIndex: 'status',
    key: 'status',
    scopedSlots: { customRender: 'status' },
    width: '12%',
    align: 'center'
  },
  {
    title: '创建人',
    dataIndex: 'sendBy',
    key: 'sendBy',
    width: '10%',
    align: 'center'
  },
  {
    title: '创建时间',
    dataIndex: 'sendTime',
    key: 'sendTime',
    width: '22%',
    align: 'center'
  },

  {
    title: '操作',
    key: 'operation',
    scopedSlots: { customRender: 'operation' },
    width: '11%',
    align: 'center'
  }
];
export default {
  name: 'addArticle',
  inject: ['closeCurrent'],
  components: {
    tinymceEditor,
    JImageUpload
  },
  data() {
    return {
      columns,
      loadingButton: false,
      articleId: '',
      wechatAppId: '',
      isClose: false,
      rightSet: true,
      uedior: null,
      articleVisible: false,
      articleAudit: false,
      publishSettingsValue: [],
      wechatMiniApp: [],
      currentWechatMiniApp: {},
      wechatMiniAppPath: [],
      selectMiniAppShow: false,
      articleForm: {
        title: '',
        author: '',
        coverPic: '',
        content: '',
        digest: ''
      },
      publishSettings: [],
      publishSettingsTab: [],
      columnChannel: [],
      current: 0,
      itemList: [
        {
          id: 0,
          url: 'https://www.weixi.qq.com?aaknx=123&oqwkssmaxa=2394303333333333',
          bt: '转折？A股冲高回落！牛市旗手回调！机会还是风险？',
          zy:
            '大盘折腾了一天，虽然短暂的摸了下3400点，但最后还是走了个冲高回落。',
          lj: 'https://www.weixi.qq.com?aaknx=123&oqwkssmaxa=239430',
          isEdit: true,
          isLock: false
        },
        {
          id: 1,
          url: 'https://www.weixi.qq.com?aaknx=123&oqwkssmaxa=239430',
          bt: '转折？A股冲高回落！牛市旗手回调！机会还是风险？',
          zy:
            '大盘折腾了一天，虽然短暂的摸了下3400点，但最后还是走了个冲高回落。',
          lj: 'https://www.weixi.qq.com?aaknx=123&oqwkssmaxa=239430',
          isEdit: true,
          isLock: false
        },
        {
          id: 2,
          url: 'https://www.weixi.qq.com?aaknx=123&oqwkssmaxa=239430',
          bt: '转折？A股冲高回落！牛市旗手回调！机会还是风险？',
          zy:
            '大盘折腾了一天，虽然短暂的摸了下3400点，但最后还是走了个冲高回落。',
          lj: 'https://www.weixi.qq.com?aaknx=123&oqwkssmaxa=239430',
          isEdit: true,
          isLock: false
        }
      ],
      overVisible: false,
      data: []
    };
  },
  created() {
    this.articleId = this.$route.query.id;
    let that = this;
    this.getArticleInfo(function() {
      that.getColumnChannel();
    });
    this.getWechatMiniApp();
    this.getMiniAppPath();
  },
  methods: {
    deleteArticle(id, index) {
      postAction(process.env.VUE_APP_CMS_CONTENT + '/cont/msg/delete', {
        id: id
      }).then(res => {
        if (res.success) {
          this.$message.success('删除成功');
          this.data.splice(index, 1);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getMyValue(val) {
      this.articleForm.content = val;
    },
    selectMiniApp(item) {
      if (this.wechatMiniAppPath.length > 0) {
        item.miniAppPath = this.wechatMiniAppPath[0].value;
      }
      item.showType = 2;
      this.currentWechatMiniApp = { ...item };
    },

    getArticleInfo(callback) {
      getAction(process.env.VUE_APP_CMS_CONTENT + '/cont/article/queryById', {
        id: this.articleId
      }).then(res => {
        if (res.success) {
          res.result.publishSettings = JSON.parse(res.result.publishSettings);
          this.articleForm = res.result;
          this.publishSettings = res.result.publishSettings;
          callback();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getColumnChannel() {
      getAction(
        process.env.VUE_APP_CMS_CONTENT + '/content/column/listRole',
        {}
      ).then(res => {
        if (res.success) {
          this.publishSettingsTab = [];
          this.columnChannel = res.result;
          //绑定选中的节点ID
          for (let index in this.columnChannel) {
            for (let pIndex in this.publishSettings) {
              if (
                this.columnChannel[index].code ==
                  this.publishSettings[pIndex].channel &&
                !this.publishSettings[pIndex].section
              ) {
                this.publishSettingsValue.push(this.columnChannel[index].id);
              } else if (
                this.columnChannel[index].code ==
                this.publishSettings[pIndex].channel
              ) {
                this.publishSettingsValue.push(
                  this.getChildColumnId(
                    this.columnChannel[index].children,
                    this.publishSettings[pIndex].section
                  )
                );
              }
            }
          }
          //绑定渠道tab
          this.changePublishSettings(this.publishSettingsValue);
          //this.publishSettingsValue
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getChildColumnId(children, column) {
      if (children == null) {
        return '';
      }
      for (let index in children) {
        let item = children[index];
        if (item.code == column) {
          return item.id;
        }
        let id = this.getChildColumnId(item.children, column);
        if (!id) {
          continue;
        }
        return id;
      }
    },
    changePublishSettings(value, label, extra) {
      this.publishSettings = [];
      let audit = false;
      //栏目选择后
      this.wechatAppId = '';
      for (let index in value) {
        let data = this.getSelectNodeData(this.columnChannel, value[index]);
        if (
          !this.wechatAppId &&
          (data.channelType == 1 || data.channelType == 2)
        ) {
          this.wechatAppId = data.channelLinkWechat;
        }
        let target = {};
        if (data.parentId == -1) {
          //-1表示选中的是渠道，渠道没有栏目
          target = {
            key: data.key,
            name: data.name,
            channel: data.code,
            section: '',
            channelType: data.channelType,
            appId: data.channelLinkWechat
          };
        } else {
          target = {
            key: data.key,
            name: data.channelName,
            channel: data.channelCode,
            section: data.code,
            channelType: data.channelType,
            appId: data.channelLinkWechat
          };
        }
        //设置审核状态
        if (!audit) {
          audit = data.channelNeedAudit;
        }
        this.publishSettings.push(target);
      }
      this.articleAudit = audit;
      this.mergePublishSettingsTab();
    },
    getSelectNodeData(data, key) {
      //获取选中栏目的节点数据
      for (let index in data) {
        let item = data[index];
        if (item.key == key) {
          return item;
        }
        let value = this.getSelectNodeData(item.children, key);
        if (!value) {
          continue;
        }
        return value;
      }
    },
    mergePublishSettingsTab() {
      //处理渠道配置，去重
      let tempArray = new Array();
      for (let index in this.publishSettings) {
        let item = this.publishSettings[index];
        let flag = false;
        for (let ti in tempArray) {
          if (item.channel == tempArray[ti].channel) {
            flag = true;
            break;
          }
        }
        if (!flag) {
          tempArray.push(item);
        }
        //复制老的设置数据
        for (let ti in tempArray) {
          let tItem = tempArray[ti];
          for (let pi in this.publishSettingsTab) {
            let pItem = this.publishSettingsTab[pi];
            if (tItem.channel == pItem.channel) {
              tempArray[ti] = pItem;
            }
          }
        }
      }

      this.publishSettingsTab = tempArray;
      //排序
      this.publishSettingsTab.sort((o1, o2) => {
        return o2.channel.localeCompare(o1.channel);
      });
    },
    // 关闭右侧设置栏
    closeRight() {
      this.isClose = !this.isClose;
      this.rightSet = !this.rightSet;
    },
    // 切换图片的回调
    onChange(current) {
      this.current = current;
    },
    // 添加列表
    addItem() {
      var obj = {
        id: this.itemList.length,
        url: '',
        bt: '',
        zy: '',
        lj: '',
        isEdit: false
      };
      this.itemList.push(obj);
    },
    // 删除
    deleteItem(id) {
      const index = this.itemList.findIndex(item => item.id === id);
      this.itemList.splice(index, 1);
    },
    // 取消添加
    cancelAdd(id) {
      if (id === this.itemList.length - 1) {
        console.log(12);
        this.itemList.splice(id, 1);
      }
      this.itemList.forEach(item => {
        if (item.id === id) {
          item.isEdit = true;
        }
        return;
      });
    },
    getWechatMiniApp() {
      getAction(process.env.VUE_APP_CMS_WECHAT + '/wechatApp/queryByType', {
        type: 3
      }).then(res => {
        if (res.success) {
          this.wechatMiniApp = res.result;
          if (this.wechatMiniApp && this.wechatMiniApp.length > 0) {
            this.selectMiniApp(this.wechatMiniApp[0]);
          }
        }
      });
    },
    saveArticle(sendFlag) {
      if (!this.articleForm.title) {
        this.$message.warning('请输入文字标题');
        return;
      }
      if (!this.articleForm.author) {
        this.$message.warning('请输入文字作者');
        return;
      }
      if (!this.articleForm.content) {
        this.$message.warning('请输入正文');
        return;
      }
      // if (!this.articleForm.coverPic) {
      //   this.$message.warning('请上传封面');
      //   return;
      // }
      if (sendFlag != 0 && this.publishSettings.length == 0) {
        this.$message.warning('请选择渠道栏目');
        return;
      }
      //保存文章
      let data = { ...this.articleForm };
      //将设置的渠道配置赋值到栏目数据中
      for (let ti in this.publishSettingsTab) {
        let tItem = this.publishSettingsTab[ti];
        for (let pi in this.publishSettings) {
          let pItem = this.publishSettings[pi];
          if (tItem.channel == pItem.channel) {
            let section = pItem.section;
            this.publishSettings[pi] = { ...tItem };
            this.publishSettings[pi].section = section;
            this.publishSettings[pi].id = '';
            this.publishSettings[pi].key = '';
            this.publishSettings[pi].name = '';
            this.publishSettings[pi].title = this.articleForm.title;
            this.publishSettings[pi].author = this.articleForm.author;
          }
        }
      }
      this.loadingButton = true;
      //0保存，1发送，2审核
      data.sendFlag = this.articleAudit ? 2 : 1;
      data.publishSettings = JSON.stringify(this.publishSettings);

      if (sendFlag == '3') {
        postAction(
          process.env.VUE_APP_CMS_CONTENT + '/cont/article/sendArticle',
          { articleId: this.articleForm.id }
        ).then(res => {
          if (res.success) {
            this.$message.success('文章发送成功');
            this.$nextTick(() => {
              this.closeCurrent();
            });
            this.overVisible = false;
          } else if ((res.result || []).length > 0) {
            this.overVisible = true;
            this.data = res.result;
          } else {
            this.$message.error(res.message);
            this.overVisible = false;
          }
          this.loadingButton = false;
        });
        return false;
      }

      postAction(
        process.env.VUE_APP_CMS_CONTENT + '/cont/article/add',
        data
      ).then(res => {
        if (res.success) {
          this.articleForm.id = res.result.articleId;
          this.$message.success('文章保存成功');
          if (sendFlag == '1') {
            //提交发送
            this.$message.info('开始发送文章到各个渠道');
            postAction(
              process.env.VUE_APP_CMS_CONTENT + '/cont/article/sendArticle',
              { articleId: this.articleForm.id }
            ).then(res => {
              if (res.success) {
                this.$message.success('文章发送成功');
                this.$nextTick(() => {
                  this.closeCurrent();
                });
              } else if ((res.result || []).length > 0) {
                this.$message.error('已经达到上限');
                this.overVisible = true;
                this.data = res.result;
              } else {
                this.$message.error(res.message);
                this.overVisible = false;
              }
              this.loadingButton = false;
            });
          } else if (sendFlag == '2') {
            this.$message.info('正在提交审核');
            postAction(
              process.env.VUE_APP_CMS_CONTENT + '/cont/article/applyAudit',
              { articleId: this.articleForm.id }
            ).then(res => {
              if (res.success) {
                this.$message.success('文章提交审核成功');
                this.$nextTick(() => {
                  this.closeCurrent();
                });
              } else {
                this.$message.error(res.message);
              }
              this.loadingButton = false;
            });
          } else {
            this.loadingButton = false;
          }
        }
      });
    },
    getMiniAppPath() {
      getAction(
        process.env.VUE_APP_CMS_SYSTEM + `/sys/dict/getDictItems/miniapp_path`,
        {}
      ).then(res => {
        if (res.success) {
          this.wechatMiniAppPath = res.result;
        }
      });
    },
    selectMiniAppOkay() {
      if (!this.currentWechatMiniApp.showType) {
        this.currentWechatMiniApp.showType = 1;
      }
      if (!this.currentWechatMiniApp.miniAppPath) {
        this.$message.warning('请选择小程序路径');
        return;
      }
      if (
        this.currentWechatMiniApp.showType == 1 &&
        !this.currentWechatMiniApp.text
      ) {
        this.$message.warning('请输入跳转文字');
        return;
      } else if (
        (this.currentWechatMiniApp.showType == 2 ||
          this.currentWechatMiniApp.showType == 3) &&
        (!this.currentWechatMiniApp.imageClick ||
          this.currentWechatMiniApp.imageClick.length == 0)
      ) {
        this.$message.warning('请上传图片');
        return;
      } else if (
        this.currentWechatMiniApp.showType == 3 &&
        !this.currentWechatMiniApp.title
      ) {
        this.$message.warning('请输入卡片标题');
        return;
      }

      let url = this.currentWechatMiniApp.miniAppPath + '?id={articleId}';
      let html = '';
      if (this.currentWechatMiniApp.showType == 1) {
        html =
          '<p style="text-align: center"><a data-miniprogram-appid="' +
          this.currentWechatMiniApp.appId +
          '" data-miniprogram-path="' +
          url +
          '" href="">' +
          this.currentWechatMiniApp.text +
          '</a></p>';
      } else if (this.currentWechatMiniApp.showType == 2) {
        html =
          '<p style="text-align: center"><a data-miniprogram-appid="' +
          this.currentWechatMiniApp.appId +
          '" data-miniprogram-path="' +
          url +
          '" href=""><img style="width: 100%" src="' +
          this.currentWechatMiniApp.imageClick +
          '" alt="" data-width="null" data-ratio="NaN"></a></p>';
      } else if (this.currentWechatMiniApp.showType == 3) {
        html =
          '<p style="text-align: center"><mp-miniprogram data-miniprogram-appid="' +
          this.currentWechatMiniApp.appId +
          '" data-miniprogram-path="' +
          url +
          '" data-miniprogram-title="' +
          this.currentWechatMiniApp.title +
          '" data-miniprogram-imageurl="' +
          this.currentWechatMiniApp.imageClick +
          '"></mp-miniprogram></p>';
      } else if (this.currentWechatMiniApp.showType == 4) {
        html =
          '<p style="text-align: center"><img width="300px" src="' +
          this.currentWechatMiniApp.linkQr +
          '" /></p>';
      }

      this.$refs.tinymceEditor.addHtml(html);
      this.selectMiniAppShow = false;
      this.currentWechatMiniApp = {};
    }
  }
};
</script>

<style scoped lang="less">
.addArticle {
  background: #f2f2f2;
  padding: 20px;
  position: relative;
  .active {
    position: absolute;
    top: 20px;
    right: 0px !important;
  }
  .close {
    display: none;
    position: absolute;
    top: 20px;
    right: 310px;
    width: 40px;
    height: 60px;
    line-height: 80px;
    text-align: center;
    background: #fff;
    border-radius: 40px 0 0 40px;
    z-index: 3;
    .anticon {
      font-size: 20px;
      color: #694ec2;
    }
  }
  .main {
    display: flex;
    .active1 {
      width: 80% !important;
      flex: unset !important;
      margin: auto;
      margin-right: 130px !important;
    }
    .left {
      flex: 3;
      margin-right: 50px;
      width: 600px;
      .top {
        background: #fff;
        padding: 20px;
        margin-bottom: 10px;
        .title {
          margin-bottom: 10px;
        }
      }
      .content {
        background: #fff;
        width: 100%;
        padding: 10px;
      }
      .preview {
        /* display: flex; */
        background: #fff;
        padding-left: 20px;
        padding-bottom: 20px;
        padding-top: 20px;
        width: 100%;
        .zhaiyao {
          display: flex;
          width: 100%;
          .img {
            width: 40%;
            img {
              height: 70px;
              border-radius: 10px;
            }
          }
          .ipt {
            margin-left: 0px;
            margin-top: 25px;
            width: 58%;
            .ant-input {
              width: 100% !important;
              height: 70px !important;
            }
          }
        }
        .btns {
          margin-top: 30px;
          text-align: center;
          .mid {
            margin: 0 40px;
          }
          .ant-btn {
            width: 100px;
            height: 40px;
          }
        }
      }
    }
    .right {
      position: relative;
      flex: 1;
      background: #fff;
      padding: 20px;
      .title {
        padding: 10px 0;
        border-bottom: 1px solid #ccc;
      }
      .cacs {
        margin-top: 20px;
        margin-bottom: 40px;
        text-align: center;
        .ant-cascader-picker {
          width: 250px !important;
        }
      }
      .bt {
        margin-bottom: 20px;
      }
      .liuyan {
        margin-top: 20px;
        .ant-cascader-picker {
          margin-left: 10px;
          width: 120px;
          .ant-input {
            font-size: 18px !important;
          }
        }
      }
      .lianjie {
        margin: 20px 0;
        .ant-input {
          margin-top: 5px;
        }
      }
      .qunfa {
        .ant-select {
          margin-left: 5px;
        }
      }
      .footer {
        position: absolute;
        bottom: 20px;
        left: 50%;
        transform: translateX(-50%);
        width: 200px;
        border-top: 1px solid #ccc;
        padding: 30px;
        text-align: center;
      }
    }
  }
  .model {
    display: flex;
    position: absolute;
    top: 15%;
    left: 30%;
    transform: translate(-30%, -20%);
    background: #f2f2f2;
    width: 900px;
    height: 550px;
    z-index: 999;
    padding: 10px;
    .left {
      flex: 1;
      background: #fff;
      margin-right: 10px;
      padding-left: 20px;
      h1 {
        font-size: 20px;
        font-weight: 700;
        margin-top: 40px;
      }
      .card {
        display: flex;
        /* justify-content: center; */
        align-items: center;
        width: 240px;
        height: 70px;
        border: 1px solid #ccc;
        margin: 40px 0;
        &:hover {
          cursor: pointer;
        }
        .avatar {
          height: 40px;
          width: 40px;
          border-radius: 50%;
          background: skyblue;
          margin-left: 25px;
          margin-right: 20px;
        }
      }
      .card-active {
        display: flex;
        /* justify-content: center; */
        align-items: center;
        width: 240px;
        height: 70px;
        border: 1px solid #1890ff;
        margin: 40px 0;
        &:hover {
          cursor: pointer;
        }
        .avatar {
          height: 40px;
          width: 40px;
          border-radius: 50%;
          background: skyblue;
          margin-left: 25px;
          margin-right: 20px;
        }
      }
    }
    .right {
      flex: 2;
      overflow-y: auto;
      background: #fff;
      h1 {
        font-size: 20px;
        text-align: center;
        font-weight: 700;
        margin-top: 40px;
      }
      .title {
        color: #333;
      }
      .cx_main {
        padding-left: 80px;
        margin-top: 40px;
        .cx_name {
          margin-bottom: 20px;
        }
        .cx_path {
          margin-bottom: 20px;
          .ant-btn {
            margin-left: 20px;
            height: 25px;
          }
        }
        .cx_show {
          margin-bottom: 20px;
        }
        .cx_item {
          p {
            margin-top: 10px;
            margin-left: 70px;
          }
          .item_img {
            .upload {
              margin-top: 20px;
              margin-left: 60px;
            }
          }
          .item_card {
            .item_c {
              display: flex;
              .card {
                width: 270px;
                border: 1px #ccc solid;
                border-radius: 4px;
                //height: 266px;
                padding: 10px 15px 15px 15px;
                .title {
                  background-repeat: no-repeat;
                  background-size: 20px;
                  background-position-y: 3px;
                  //padding-left: 30px;
                  font-size: 13px;
                  color: #888;
                }
                .upload {
                  margin-top: 10px;
                }
                > p {
                  margin-left: 0px;
                }
              }
            }
          }
        }
      }
      .footer {
        text-align: center;
        margin-top: 60px;
        .ant-btn {
          width: 100px;
        }
      }
    }
  }

  .articleModel {
    display: flex;
    position: absolute;
    top: 20%;
    left: 50%;
    transform: translate(-50%, -20%);
    background: #f2f2f2;
    width: 900px;
    z-index: 999;
    padding: 10px;
    .left {
      position: relative;
      flex: 1;
      background: #fff;
      padding-left: 20px;
      margin-right: 10px;
      h1 {
        font-size: 18px;
        font-weight: 700;
      }
      .ant-carousel {
        width: 300px;
        height: 130px;
        /deep/ .custom-slick-arrow {
          width: 25px;
          height: 25px;
          font-size: 30px;
          color: #333;
          opacity: 0.3;
        }
        .custom-slick-arrow:before {
          display: none;
        }
        .custom-slick-arrow:hover {
          opacity: 0.5;
        }
        .img {
          width: 100%;
          height: 130px;
          background: skyblue;
        }
        .slick-slide {
          text-align: center;
          overflow: hidden;
          height: 100%;
          h3 {
            /* color: #fff; */
          }
        }
      }
      h2 {
        font-size: 18px;
        font-weight: 700;
        margin-top: 30px;
      }
      .yulan1 {
        .tj {
          position: relative;
          .le {
            position: absolute;
            left: 25px;
            top: 10px;
            height: 8px;
            width: 80px;
            border-top: 3px solid #ccc;
            border-bottom: 1px solid #ccc;
          }
          .rig {
            position: absolute;
            right: 25px;
            top: 10px;
            height: 8px;
            width: 80px;
            border-top: 3px solid #ccc;
            border-bottom: 1px solid #ccc;
          }
          h3 {
            font-weight: 700;
            font-size: 16px;
            text-align: center;
            margin-top: 10px;
          }
          .a_item {
            display: flex;
            width: 250px;
            height: 60px;
            background: pink;
            margin-left: 25px;
            margin-bottom: 20px;
            .zuo {
              width: 60px;
              height: 60px;
              background: powderblue;
              margin-right: 5px;
            }
            .you {
              width: 190px;
              font-size: 12px;
              h4 {
                font-weight: 700;
              }
              p {
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
              }
            }
          }
        }
      }
      .yulan2 {
        .title {
          margin-left: 20px;
          display: flex;
          align-items: center;
          .dsx {
            display: inline-block;
            width: 8px;
            height: 25px;
            background: #90d7ec;
            margin-right: 10px;
          }
          .title_item {
            color: #49b779;
          }
        }
        .yl_item {
          display: flex;
          align-items: center;
          margin-top: 10px;
          margin-left: 20px;
          margin-bottom: 20px;
          .l {
            color: #3b8274;
          }
          .m {
            display: inline-block;
            width: 3px;
            height: 15px;
            background: #c4dad5;
            margin: 0 10px;
          }
          .y {
            width: 190px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
        }
      }
      .bc {
        width: 150px;
        border-top: 1px solid #ccc;
        padding-top: 20px;
        text-align: center;
        margin-top: 50px;
        margin-left: 75px;
        margin-bottom: 20px;
      }
    }
    .right {
      flex: 2;
      /* background: #fff; */
      /* padding-left: 20px; */
      .top {
        background: #fff;
        padding-left: 20px;
        padding-bottom: 20px;
        margin-bottom: 10px;
        h1 {
          font-size: 18px;
          font-weight: 700;
          margin-bottom: 30px;
        }
        .guize {
          .ant-btn {
            color: #44a4ff;
            height: 25px;
            width: 70px;
            font-size: 12px;
            text-align: center;
          }
        }
      }
      .bott {
        background: #fff;
        .active2 {
          background: #eee;
        }
        .bott_item {
          position: relative;
          .lock {
            position: absolute;
            top: 80px;
            left: 10px;
            .anticon {
              font-size: 25px;
              color: #333;
            }
          }
          .delete {
            position: absolute;
            top: 130px;
            left: 10px;
            .anticon {
              font-size: 25px;
              color: #333;
            }
          }
          .bott_top {
            display: flex;
            padding: 10px 20px;
            .handle {
              height: 30px;
              width: 450px;
              border-bottom: 1px solid #ccc;
              margin-left: 20px;
              text-align: right;
            }
          }
          .bott_bot {
            padding-left: 50px;
            margin-top: 0px;
            font-size: 10px;
            padding-bottom: 20px;
            border-bottom: 1px solid #ccc;
            .h_item {
              margin-bottom: 10px;
              .ant-btn {
                width: 430px;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                padding: 0 !important;
                text-align-last: left;
              }
              .current1 {
                display: inline-block;
                width: 400px;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                line-height: 12px;
              }
            }
          }
        }
      }
      .add {
        padding-top: 30px;
        padding-bottom: 30px;
        width: 100%;
        /* height: 300px; */
        text-align: center;
        background: #fff;
        .ant-btn {
          width: 100px;
        }
      }
    }
  }
}
</style>
